// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import { defaultModalsState, ModalsContext } from 'Contexts/ModalsContext';
import ModalManager from 'Containers/ModalManager/ModalManager';
import ProductPicturesModalComponent from 'Components/Products/ProductPicturesModal';

const ProductPicturesModal = memo(() => {
  const { modalData, resetModal } = useContextSelector(ModalsContext, data => ({
    modalData: data.modalState[defaultModalsState.PRODUCT_PICTURES.key],
    resetModal: () => data.resetModal(defaultModalsState.PRODUCT_PICTURES.key)
  }));
  const [selectedSlide, selectSlide] = useState(null);

  useEffect(() => {
    selectSlide(modalData.state.selected || 0);
  }, [modalData.state]);

  useEffect(() => resetModal, []);

  return (
    <ModalManager open={ modalData.state.open }>
      <ProductPicturesModalComponent
        onClose={ resetModal }
        open={ modalData.state.open }
        pictures={ modalData.state.pictures || [] }
        selected={ selectedSlide }
        onChange={ selectSlide }
      />
    </ModalManager>
  );
});

export default ProductPicturesModal;
